import { unflatten } from 'flat';
import space from 'to-space-case';
import JSZip from 'jszip';
import Docxtemplater from 'docxtemplater';
import InspectModule from 'docxtemplater/js/inspect-module';
import { inputTypes, inputUi } from './Constants';

export const generateUiSchema = (schema) => {
  var properties = schema.properties;
  var response = {};

  for (const prop in properties) {
    const propertiesTwo = properties[prop];
    const objUi = {};
    for (const propTwo in propertiesTwo.properties) {
      const propertiesThree = propertiesTwo.properties[propTwo];

      if (inputUi.includes(propertiesThree.type)) {
        if (propertiesThree.type === 'integer') {
          objUi[propTwo] = { 'ui:widget': 'updown' };
        }
      }
    }
    response[prop] = objUi;
  }
  return response;
};

export const generateSchema = async (fileBlob, t) => {
  const zip = new JSZip(fileBlob.target.result);
  const iModule = InspectModule();
  const options = {
    modules: [iModule],
    paragraphLoop: true,
    linebreaks: true
  };

  const doc = new Docxtemplater(zip, options);

  try {
    doc.render();

    let { strTags, loopTags } = getTags(iModule);
    strTags = checkStrTags(strTags, t);

    if (strTags.message) throw strTags;
    strTags.documento_nombre = '';
    strTags.documento_descripcion = '';

    const treeStrTags = unflatten(strTags, { delimiter: '_' });

    let schemaPadre = {
      title: t('templateDragAndDrop:schemaTitle'),
      description: t('templateDragAndDrop:description'),
      type: 'object',
      required: [],
      properties: {}
    };
    schemaPadre = nodeProcessObjects(treeStrTags, schemaPadre, t);
    if (Object.keys(loopTags).length !== 0) {
      schemaPadre = nodeProcessLoop(loopTags, schemaPadre, t);
    }

    return schemaPadre;
  } catch (error) {
    throw error;
  }
};

const getTags = (iModule) => {
  const structuredTags = iModule.getStructuredTags();
  const tags = iModule.getTags();
  let strTags = {};
  let loopTags = {};
  structuredTags.forEach((structuredTag) => {
    const key = structuredTag.value;
    if (structuredTag.module === 'loop') {
      loopTags[key] = tags[key];
    } else {
      strTags[key] = tags[key];
    }
  });

  return { strTags, loopTags };
};

const nodeProcessObjects = (tree, currentSchema, t) => {
  const keys = Object.keys(tree);
  keys.forEach(key => {
    const nextSchema = { type: 'object', title: space(key).toUpperCase(), properties: {}, required: [] };
    Object.keys(tree[key]).forEach(level2 => {
      nextSchema.properties[level2] = detectTypeInput(level2, t);
      if (key === 'documento' && level2 === 'descripcion') return;
      nextSchema.required.push(level2);
    });
    currentSchema.properties[key] = nextSchema;
  });

  return currentSchema;
};

const nodeProcessLoop = (tree, currentSchema, t) => {
  Object.keys(tree).forEach(key => {
    const nextSchema = { type: 'array', title: space(key).toUpperCase(), items: {}, required: [] };
    const items = { type: 'object', title: space(key), properties: {}, required: [] };
    Object.keys(tree[key]).forEach(keyChild => {
      items.properties[keyChild] = detectTypeInput(keyChild, t);
      items.required.push(keyChild);
    });
    nextSchema.items = items;
    currentSchema.properties[key] = nextSchema;
  });

  return currentSchema;
};

const detectTypeInput = (level2, t) => {
  let title = level2.charAt(0).toUpperCase() + level2.slice(1);

  if (level2.match(/[A-Z][a-z]+/g)) {
    title = title.match(/[A-Z][a-z]+/g).join(' ');
  }

  let valueReturn = { type: 'string', title: title };
  const getAllKeys = Object.keys(inputTypes);

  getAllKeys.forEach(function (keyName) {
    if (level2.indexOf(keyName) !== -1) {
      var newInputTypes = {};
      if (Object.keys(inputTypes[keyName]).includes('title')) {
        inputTypes[keyName].title = title;
        newInputTypes = Object.assign({}, inputTypes[keyName]);
      }
      valueReturn = newInputTypes;
    }
  });
  valueReturn.title = valueReturn.title.replace('Anyo', t('templateDragAndDrop:year'));
  return valueReturn;
};

const checkStrTags = (tags, t) => {
  const UNDERSCORE_LIMIT = 2;
  if (Object.entries(tags).length === 0) return Error(t('templateDragAndDrop:noFields'));
  const checkMaxUnderscore = Object.keys(tags).filter(key => key.split('_').length > UNDERSCORE_LIMIT);
  const checkMinUnderscore = Object.keys(tags).filter(key => key.split('_').length < UNDERSCORE_LIMIT);
  const errorMsg = checkError(t, checkMaxUnderscore) || checkError(t, checkMinUnderscore);
  return errorMsg || tags;
};

const checkError = (t, errors) => {
  return errors.length ? new Error(t('templateDragAndDrop:format') + '{' + `${errors.join('} {')}` + '}\'') : false;
};
